"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CollisionType;
(function (CollisionType) {
    CollisionType["NONE"] = "NONE";
    CollisionType["TOP"] = "TOP";
    CollisionType["BOTTOM"] = "BOTTOM";
})(CollisionType || (CollisionType = {}));
exports.default = CollisionType;
//# sourceMappingURL=CollisionType.js.map